import type { WidgetMessageEventPayload } from './types.js';

export type WidgetThreadSignalPayload = {
  threadId: string;
  siteFingerprintId?: string;
};

/** Full event body: `{ message: ThreadApiMessage }`. */
export function normalizeWidgetMessagePayload(
  payload: unknown,
): WidgetMessageEventPayload | null {
  if (!payload || typeof payload !== 'object') return null;
  const record = payload as Record<string, unknown>;
  if (record.message && typeof record.message === 'object') {
    return payload as WidgetMessageEventPayload;
  }
  return null;
}

/**
 * Lightweight WS body: `{ thread_id, site_fingerprint_id? }` without `message`.
 * Backend may emit this as a refetch signal before the message row is ready.
 */
export function parseWidgetThreadSignal(
  payload: unknown,
): WidgetThreadSignalPayload | null {
  if (!payload || typeof payload !== 'object') return null;
  const record = payload as Record<string, unknown>;

  if (record.message && typeof record.message === 'object') return null;

  const threadIdRaw = record.thread_id;
  const threadIdNum = Number(threadIdRaw);
  if (!Number.isFinite(threadIdNum) || threadIdNum <= 0) return null;

  const fingerprint = record.site_fingerprint_id;
  return {
    threadId: String(threadIdNum),
    siteFingerprintId:
      typeof fingerprint === 'string' && fingerprint.trim()
        ? fingerprint.trim()
        : undefined,
  };
}
